export { MainGallery } from './MainGallery';
export type { GalleryEvents } from './MainGallery';
